import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ModalType } from "../modal/LeadModal";
import { getHeaderActions } from "./headerActions.model";

type Props = {
    canShowAuthButtons: boolean;
    onOpenModal: (type: ModalType) => void;
    variant?: "desktop" | "mobile";
    onNavigate?: () => void; // для закрытия mobile menu
};

export const HeaderActions: React.FC<Props> = ({
                                                   canShowAuthButtons,
                                                   onOpenModal,
                                                   variant = "desktop",
                                                   onNavigate,
                                               }) => {
    const { isAuth, isAdmin } = useAuth();

    if (!canShowAuthButtons) return null;

    const actions = getHeaderActions({ isAuth, isAdmin });

    const rootClass = variant === "desktop" ? "header-actions" : "mobile-menu-actions";
    const linkClass =
        variant === "desktop" ? "nav-link header-action-link" : "mobile-menu-link";
    const ctaClass = variant === "desktop" ? "header-cta" : "mobile-menu-cta";

    return (
        <div className={rootClass}>
            {actions.map((a, idx) => {
                if (a.kind === "link") {
                    return (
                        <NavLink
                            key={`${a.to}-${idx}`}
                            to={a.to}
                            onClick={onNavigate}
                            className={({ isActive }) =>
                                linkClass + (variant === "desktop" && isActive ? " nav-link--active" : "")
                            }
                        >
                            {a.label}
                        </NavLink>
                    );
                }

                return (
                    <button
                        key={`${a.modal}-${idx}`}
                        type="button"
                        className={ctaClass}
                        onClick={() => {
                            onOpenModal(a.modal);
                            onNavigate?.();
                        }}
                    >
                        {a.label}
                    </button>
                );
            })}
        </div>
    );
};
